import {
  call, put, takeEvery, all, select,
} from 'redux-saga/effects';
import * as actions from '../../../actions/analytics';
import { matchesType } from '../helper';
import { getBusinessUnitTier } from '../../../api/businessUnitApi';
import { getBusinessUserDetails, getAnalyticsUserId } from '../../../api/businessUserApi';

async function loadTrackingScript(): Promise<boolean> {
  window.analytics.load(process.env.REACT_APP_SegmentIoKey || '');

  return new Promise((resolve, reject) => {
    const readyInterval = setInterval(() => {
      try {
        if (window.analytics) {
          clearInterval(readyInterval);
          resolve(true);
        }
      } catch (error) {
        clearInterval(readyInterval);
        reject(error);
      }
    });
  });
}

function* loadAnalytics(): any {
  try {
    yield call(loadTrackingScript);
    const businessUserDetails = yield getBusinessUserDetails();
    const {
      id, name, email, locale,
    } = businessUserDetails.businessUser;

    const analyticsUser = yield getAnalyticsUserId(email);
    if (analyticsUser) {
      window.analytics.identify(analyticsUser.id, {
        id, name, email, locale,
      });
    }

    yield put(actions.analyticsLoaded({ isFetching: true }));
  } catch (err) {
    console.log(err);
  }
}

function* track(action: ReturnType<typeof actions.track>): any {
  if (window.analytics) {
    const { details } = yield select((state) => state.shop);
    const tier = details.businessUnitId ? yield getBusinessUnitTier(details.businessUnitId) : '';

    const payload = {
      source: 'BillingApp',
      context: 'Ecommscript billing app',
      businessUnitId: details.businessUnitId,
      tierName: tier.name,
      integration: details.integration,
      ...action.payload.eventData,
    };
    window.analytics.track(action.payload.eventName, payload);
  }
}

function pageView(action: ReturnType<typeof actions.pageView>): any {
  if (window.analytics) {
    window.analytics.page(action.payload.path, action.payload.eventData);
  }
}

function* analytics(): any {
  yield all([
    takeEvery(matchesType(actions.loadAnalytics), loadAnalytics),
    takeEvery(matchesType(actions.track), track),
    takeEvery(matchesType(actions.pageView), pageView),
  ]);
}

export { analytics };
